<template>
  <div class="new-project-environment">
    <div class="left-section">
      <div class="section-title">
        {{ $t('newProject.project.configuration') }}
      </div>
      <div class="external-section">
        <div class="radio-section">
          <div class="checkbox-section">
            <div>
              <input type="radio" name="radio" :value="configurationConst.EXTERNAL" v-model="configuration.type" />
              <label class="checkbox-label strong-label">{{ $t('newProject.external') }}</label>
            </div>
            <span class="checkbox-description">
              {{ $t('newProject.environment.external.description') }}
            </span>
          </div>
        </div>
      </div>
      <div class="internal-section">
        <div class="radio-section">
          <div class="checkbox-section">
            <div>
              <input
                type="radio"
                name="radio"
                :value="configurationConst.INTERNAL"
                v-model="configuration.type"
                disabled
              />
              <label class="checkbox-label inactive strong-label">{{ $t('newProject.internal') }}</label>
            </div>
            <span class="checkbox-description">
              {{ $t('newProject.environment.internal.description') }}
              <div class="coming-soon-box">{{ $t('coming.soon') }}</div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="right-section">
      <div class="section-title right-section-title">
        {{ $t('newProject.environment.testingType') }}
      </div>

      <div class="buttons-section black-gray-box">
        <div
          @click="onBoxTypeClicked(testBoxTypes.BLACK_BOX)"
          class="black-box testing-config-box"
          :class="{ active: configuration.data === testBoxTypes.BLACK_BOX }"
        >
          <div>
            <label class="strong-label">{{ $t('newProject.black.box') }}</label>
          </div>
          <span class="box-description">{{ $t('newProject.environment.blackBox.description') }}</span>
        </div>
        <div
          @click="onBoxTypeClicked(testBoxTypes.GRAY_BOX)"
          class="gray-box testing-config-box"
          :class="{ active: configuration.data === testBoxTypes.GRAY_BOX }"
        >
          <div>
            <label class="strong-label">{{ $t('newProject.gray.box') }}</label>
          </div>
          <span class="box-description">{{ $t('newProject.environment.grayBox.description') }}</span>
        </div>
      </div>

      <div class="section-title right-section-title">
        {{ $t('newProject.environment.scopeCollectionType') }}
      </div>

      <div class="buttons-section">
        <div
          @click="onModeClicked(testModeTypes.AUTOMATED)"
          class="black-box testing-config-box"
          :class="{ active: envData.mode === testModeTypes.AUTOMATED }"
        >
          <div>
            <label class="strong-label">{{ $t('newProject.automated') }}</label>
          </div>
          <span class="box-description">{{ $t('newProject.environment.automated.description') }}</span>
        </div>
        <div
          @click="onModeClicked(testModeTypes.MANUAL)"
          class="gray-box testing-config-box"
          :class="{ active: envData.mode === testModeTypes.MANUAL }"
        >
          <div>
            <label class="strong-label">{{ $t('newProject.manual') }}</label>
          </div>
          <span class="box-description">{{ $t('newProject.environment.manual.description') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  testBoxTypes as TEST_BOX_TYPES,
  configuration as CONFIGURATION,
  testModeTypes as TEST_MODE_TYPES,
} from '@/constants/projects';

export default {
  name: 'NewProjectEnvironment',
  components: {},
  props: {
    newProject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      configuration: this.newProject.projectEnvironmentData.configuration,
      envData: this.newProject.projectEnvironmentData,
    };
  },
  computed: {
    testBoxTypes() {
      return TEST_BOX_TYPES;
    },
    configurationConst() {
      return CONFIGURATION;
    },
    testModeTypes() {
      return TEST_MODE_TYPES;
    },
  },
  watch: {
    newProject: {
      deep: true,
      handler() {
        this.$emit('setRequiredDataForStep', 2);
      },
    },
    configuration: {
      deep: true,
      handler() {
        this.$emit('setRequiredDataForStep', 2, true);
      },
    },
  },
  methods: {
    onBoxTypeClicked(data) {
      this.configuration.data = data;
    },
    onModeClicked(data) {
      this.envData.mode = data;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.section-title {
  width: 100%;
  height: rem(16);
  text-transform: uppercase;
  color: var(--text-secondary);
  font-size: $font-size-sm;
  font-weight: 600;
  letter-spacing: 0.96px;
  line-height: rem(16);
}

.strong-label {
  font-weight: bold;
}

.left-section {
  float: left;
  width: rem(332);
  min-height: rem(376);
  height: fit-content;
  margin: rem(24) rem(52) rem(233) rem(32);

  .radio-section {
    display: inline-table;

    label {
      width: rem(163);
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: rem(16);
      vertical-align: super;
      position: relative;
    }

    span {
      display: inline-block;
      position: relative;
      padding-left: rem(28);
      color: var(--text-secondary);
    }

    input {
      width: rem(20);
      height: rem(20);
      margin: 0 $space-2 $space-2 0;
    }
  }

  .external-section {
    padding-top: $space-4;
  }

  .internal-section {
    margin-top: rem(50);
  }
}

.right-section {
  float: left;
  width: rem(448);
  min-height: rem(585);
  margin-top: rem(24);
  margin-right: rem(32);
  margin-bottom: rem(24);
  padding-top: rem(42);

  border-radius: $radius-md;
  background-color: var(--bg-secondary);

  height: fit-content;
  padding-bottom: $space-2;

  .right-section-title {
    margin-left: rem(41);
  }

  .buttons-section {
    .testing-config-box {
      cursor: pointer;
      margin-left: rem(41);
      margin-right: rem(28);
      padding: $space-4 $space-2 rem(21) rem(25);
      box-sizing: border-box;
      width: rem(370);
      outline: 1px solid var(--border-secondary);
      border-radius: $radius-sm;
      background-color: var(--bg-primary);

      label {
        color: var(--text-primary);
      }

      &.active {
        outline: 2px solid var(--brand-primary);
      }

      .box-description {
        padding-right: rem(15);
        color: var(--text-secondary);
        font-size: $font-size-base;
        line-height: rem(18);
      }

      &.black-box {
        margin-bottom: $space-3;
        margin-top: $space-4;
      }
    }
  }

  .auto-manual-section {
    margin-top: rem(32);
    text-align: center;

    .auto-manual-wrapper {
      display: inline-block;
      height: rem(34);
      line-height: $font-size-base;

      border: 1px solid var(--border-secondary);
      border-radius: $radius-md;
      background-color: var(--bg-primary);
    }

    span {
      label {
        position: relative;
        top: $space-2;
      }
    }

    .auto {
      width: rem(98);
    }
    .manual {
      width: rem(77);
    }

    .tab {
      cursor: pointer;

      label {
        cursor: pointer;
      }

      display: inline-block;

      box-sizing: border-box;
      height: rem(32);

      color: var(--text-secondary);
      font-size: $font-size-base;
      font-weight: 500;
      letter-spacing: 0;
      line-height: $font-size-base;
    }

    .active {
      border: 1px solid var(--brand-primary);
      border-radius: $radius-md;
      background-color: var(--brand-primary);
      color: #ffffff;
    }
  }
}

.coming-soon {
  height: rem(10);
  width: rem(78);
  color: var(--status-warning);
  font-size: $font-size-2xs;
  letter-spacing: 0;
  line-height: rem(10);
  text-align: center;
  display: table;
  padding-left: rem(17);
}

.inactive {
  color: var(--text-secondary) !important;
  cursor: default !important;
}

.black-gray-box:after {
  content: '';
  width: rem(370);
  margin-left: rem(41);
  margin-top: rem(20);
  margin-bottom: rem(14);
  border-bottom: solid 1px var(--border-secondary);
  display: inline-block;
  left: 0;
  z-index: 1;
}

.coming-soon-box {
  color: var(--status-warning);
  text-align: center;
  box-sizing: border-box;
  height: rem(21);
  width: rem(95);
  border: 1px solid var(--status-warning);
  border-radius: $radius-sm;
  display: table;
  margin-top: rem(13);
}
</style>
